<template>
  <div v-if="data" v-title :data-title="page_title">


    <div class="head cle">
      <div class="dm cle" v-if="data">
        <div class="logo fl" :class="show_logo ? '' : 'logo_on'" @click="goHome">
          <img :src="data.list[17].varvalue" class="i1" />
          <img :src="data.list[16].varvalue" class="i2" />

        </div>
        <div class="menu fr" @click="navStyle">
          <div class="show_navs_txt" v-if="!if_show">

            <div class="gps">
              <span @click="goTopage('administration')">公司管理层</span>
              <span @click="goTopage('course')">企业历程</span>
              <span @click="goTopage('contactus')">联系我们</span>
            </div>


          </div>
          <div class="gpo" :class="if_show ? 'gpo_on' : ''">
            <div class="dd">
              <i v-for="item in 3"></i>
            </div>

          </div>
        </div>
      </div>




    </div>
    <!-- 三个大的显示层 -->
    <div class="box_navs cle" v-if="if_show">
      <div class="item item1" @click="goTopage('administration')">
        <i></i>
        <div class="text_box">
          <div class="t1">
            Management Team
          </div>
          <div class="t2">
            公司管理层
          </div>
          <div class="t3">
            Full media marketing service provider
          </div>
        </div>
      </div>
      <div class="item item2" @click="goTopage('course')">
        <i></i>
        <div class="text_box">
          <div class="t1">
            Company History
          </div>
          <div class="t2">
            企业历程
          </div>
          <div class="t3">
            Full media marketing service provider
          </div>
        </div>
      </div>
      <div class="item item3" @click="goTopage('contactus')">
        <i></i>
        <div class="text_box">
          <div class="t1">
            Contact Us
          </div>
          <div class="t2">
            联系我们
          </div>
          <div class="t3">
            Full media marketing service provider
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    postconfigAPI
  } from '../../api/api.js'
  export default {
    name: "Head",
    props: {
      index: {
        type: String,
        default: '0',



      }
    },
    watch: {

      // $route(to, from) {
      //   console.log(to);
      //   console.log(from);
      // }
    },

    data() {
      return {
        if_show: false, //显示导航
        data: null,
        show_logo: true,
        title_page: null, //页面标题
        page_title: null, //页面标题
      }
    },
    methods: {
      goHome() {
        this.$router.push('/')
      },
      navStyle() {
        this.if_show = !this.if_show;
        //  console.log(this.if_show);

      },
      goTopage(em) {
        this.$router.push({
          path: em
        })
      },
      //获取配置
      getConfig() {
        var that = this
        postconfigAPI().then(function(res) {
          // console.log(res);
          that.data = res.data.data;
          //  console.log(that.data);
        }).catch(function(err) {

        })
      },
      handleScroll(e) {
        var that = this;
        let scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        // console.log(scrollTop);
        if (scrollTop > 1100) {
          that.show_logo = false;
        } else {
          that.show_logo = true;
        }
      },



    },
    created(e) {
      console.log('路由');
      // console.log(this.$router.history.current.meta.title);
      this.page_title = this.$router.history.current.meta.title;
      this.getConfig();
      window.addEventListener("scroll", this.handleScroll, true);

    },
  }
</script>

<style lang="less">
  @import '../assets/css3.css';

  .head {
    position: fixed;
    top: 0px;
    z-index: 99999999;
    width: 100%;

    .dm {
      padding: 40px 60px;
    }

    .logo {
      width: 116px;
      cursor: pointer;
      height: 43px;
      position: relative;

      img {
        position: absolute;
        top: 0px;
        left: 0px;
      }

      .i2 {
        opacity: 0;
      }

    }

    .logo_on {
      .i1 {
        opacity: 0;
      }

      .i2 {
        opacity: 1;
      }
    }

    .menu {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      cursor: pointer;

      position: relative;

      img {
        position: relative;
        z-index: 100;
      }


      .show_navs_txt {
        position: absolute;
        width: 0;
        opacity: 0;
        overflow: hidden;
        height: 100%;
        line-height: 50px;
        padding-right: 50px;
        color: #fff;
        left: 48px;
        transform: translateX(-100%);
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50px;

        .gps {
          span {
            display: inline-block;
            width: 30%;
            font-size: 14px;
            text-align: center;
          }

          span:hover {
            text-decoration: underline;
          }
        }
      }

      .gpo {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background: #D9D9D9;
        position: relative;
        z-index: 999;

        .dd {
          position: absolute;
          top: 55%;
          left: 50%;
          width: 40px;
          transform: translate(-50%, -50%);

          i {
            display: block;
            width: 70%;
            margin: 0px auto;
            height: 3px;
            background: #0c0c0d;
            border-radius: 4px;
            margin-bottom: 5px;
          }
        }


      }

      .gpo_on {
        i {
          position: relative;
        }

        i:nth-child(3) {
          opacity: 0;
        }

        i:nth-child(1) {
          transform: rotate(45deg);
          top: 4px;
          left: 0;
        }

        i:nth-child(2) {
          transform: rotate(-45deg);
          top: -4px;
        }
      }

    }

    .menu:hover img {
      transform: rotate(90deg);
    }

    .menu:hover .show_navs_txt {
      width: 300px;
      opacity: 1;
    }
  }


  .box_navs {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    z-index: 10;
    overflow: hidden;


    .item {
      width: 33.333%;
      height: 100%;
      display: block;
      background: #000000;
      float: left;
      position: relative;


      .text_box {
        color: #fff;
        text-align: left;
        position: absolute;
        bottom: 10%;
        padding: 50px;

        .t1 {
          font-size: 48px;
          font-weight: bold;
          position: relative;
          font-family: Arial, Helvetica, sans-serif;
          margin-bottom: 6px;
          animation-name: exampletxt;
          animation-duration: 1.1s;
        }

        .t2 {
          font-size: 38px;
          margin-bottom: 20px;
          position: relative;
          animation-name: exampletxt;
          animation-duration: 1.2s;
        }

        .t3 {
          font-size: 22px;
          overflow-x: overlay;
          width: 100%;
          position: relative;
          animation-name: exampletxt;
          animation-duration: 1.3s;

          span {
            position: relative;
            left: -100%;
            opacity: 0;
          }
        }



      }

      @keyframes exampletxt {
        from {
          left: -100%;
        }

        to {
          left: 0;
        }
      }

      i {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0px;
        animation-name: example;
        animation-duration: 1s;
        display: block;
      }

      @keyframes example {
        from {
          left: -100%;
        }

        to {
          left: 0;
        }
      }

    }

    .item1 {
      i {
        background: #3d3e40;
      }
    }

    .item2 {
      i {
        background: #0c0c0d;
      }

    }

    .item3 {
      i {
        background: #18191a;
      }
    }



  }


  .box_navs_on {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Head.vue